import React from 'react';
import { useI18n } from '@whizz/react-i18n';
import AdminDashboardLayout from '../../../layouts/AdminDashboardLayout';
import { SchoolsTable } from './modules/SchoolsTable';
import { AdminListTabs } from '../components/AdminListTabs';
import { useHistory } from 'react-router-dom';
import { ADMIN_ROUTES, ROUTES } from '../../../util/vars';

const SchoolListPageComponent = () => {
  const { translate: t } = useI18n();
  const history = useHistory();

  const gotoSchool = (schoolId: number) => {
    history.push(`${ROUTES.superAdmin}${ADMIN_ROUTES.school}/${schoolId}${ADMIN_ROUTES.implementation.home}${ADMIN_ROUTES.implementation.weeklyLeadersEmails}`);
  };

  return (
    <AdminDashboardLayout title={t('pages.ADMIN.HEADER')}>
      <AdminListTabs active={'schools'} />
      <SchoolsTable onClickEdit={gotoSchool} />
    </AdminDashboardLayout>
  );
};

export { SchoolListPageComponent };
